import { QueryClient } from '@tanstack/react-query';

// Single shared client so non-React code (e.g. logout) can clear the cache too.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,        // 1 min default; overridden per query
            gcTime: 5 * 60 * 1000,       // keep unused data 5 min
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});
